class SetAchievementData {
  protected allowed(): boolean {
    return (
      this.store.promo.hasPromoApp() &&
      (this.store.promo.isAchievement || this.store.promo.isAchievementBG || this.store.promo.isAchievementFS)
    );
  }

  execution(): void {
    if (!this.allowed()) return;

    promoApp.eventEmitter.emit(
      'SET_ACHIEVEMENT_DATA',
      this.store.promo.achievement || this.store.promo.achievementBG || this.store.promo.achievementFS
    );
  }

  get store() {
    return game.store;
  }
}

export { SetAchievementData };
